import { DialogCheckBox } from 'components/DialogCheckBox';
import { useCompanies } from 'hooks/useCompanies';
import { useDisclose } from 'hooks/utilHooks';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { ICompany } from 'types/Company';
import { maskCNPJ } from 'util/masks';

import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Stack, TableCell, TableRow } from '@mui/material';

export interface ICompanyRow {
  company: ICompany;
}

export const CompanyRow: React.FC<ICompanyRow> = ({ company }) => {
  let history = useHistory();
  let { path } = useRouteMatch();

  // const successModal = useDisclose();
  const { isOpen, onClose, onOpen } = useDisclose();

  const { deleteItem, loadingDelete } = useCompanies();

  const deleteCompany = () => {
    deleteItem(company._id);

    onClose();
    // successModal.onOpen();
  };

  const handleEdit = () => {
    history.push(`${path}/edit/${company._id}`);
  };

  const handleView = () => {
    history.push(`${path}/view/${company._id}`);
  };

  return (
    <>
      <TableRow key={company.socialReason} hover>
        <TableCell component="th" scope="row">
          {company.socialReason}
        </TableCell>

        <TableCell>{maskCNPJ(company.cnpj || '')}</TableCell>

        <TableCell>
          <Stack flexDirection="row" gap="8px">
            <IconButton aria-label="edit" color="inherit" onClick={handleEdit}>
              <CreateIcon />
            </IconButton>

            <IconButton aria-label="view" color="inherit" onClick={handleView}>
              <SearchIcon />
            </IconButton>

            <IconButton aria-label="delete" color="inherit" onClick={onOpen}>
              <DeleteIcon />
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>

      <DialogCheckBox
        title="Exclusão permanente"
        text="Essa ação é permanente, você deseja continuar e excluir todos os
        dados dessa empresa?"
        isOpen={isOpen}
        onClose={onClose}
        loadingDelete={loadingDelete.loading}
        deleteItem={deleteCompany}
      />

      {/* <DialogConfirmation
        title="Exclusão permanente da empresa"
        text="Exclusão realizada com sucesso!"
        isOpen={successModal.isOpen}
        onClose={successModal.onClose}
      /> */}
    </>
  );
};
